import produce from "immer"
import { ASC } from "const"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

const initProjectUserGroupState: types.ProjectUserGroupState = {
    userGroupList: null,
    groupUserList: null,

    assignedGroups: {
        groupIds: null,
        sortColumn: "name",
        sortOrder: ASC,
        filters: {
            search: null,
        },
    },
    notAssignedGroups: {
        groupIds: null,
        sortColumn: "name",
        sortOrder: ASC,
        filters: {
            search: null,
        },
        selected: null,
    },

    assignedUsers: {
        userIds: null,
        sortColumn: "firstName",
        sortOrder: ASC,
        filters: {
            search: null,
        },
    },
    notAssignedUsers: {
        userIds: null,
        sortColumn: "firstName",
        sortOrder: ASC,
        filters: {
            search: null,
        },
        selected: null,
    },

    reloadUserGroupList: true,
    reloadGroupUserList: true,
}

const projectUserGroupReducer = produce((
    draft: types.ProjectUserGroupState = initProjectUserGroupState,
    action: ActionTypes = null,
): types.ProjectUserGroupState => {
    switch (action.type) {
        case types.PROJECT_USER_GROUP_LIST:
            draft.userGroupList = action.userGroupList
            return draft

        case types.PROJECT_GROUP_USER_LIST:
            draft.groupUserList = action.groupUserList
            return draft

            // projectuser groups

        case types.ASSIGNED_PROJECT_USER_GROUP_IDS:
            draft.assignedGroups.groupIds = action.groupIds
            return draft

        case types.ASSIGNED_PROJECT_USER_GROUP_SORT:
            draft.assignedGroups.sortColumn = action.sortColumn
            draft.assignedGroups.sortOrder = action.sortOrder
            return draft

        case types.ASSIGNED_PROJECT_USER_GROUP_FILTERS:
            draft.assignedGroups.filters = action.filters
            return draft

        case types.NOT_ASSIGNED_PROJECT_USER_GROUP_IDS:
            draft.notAssignedGroups.groupIds = action.groupIds
            return draft

        case types.NOT_ASSIGNED_PROJECT_USER_GROUP_SORT:
            draft.notAssignedGroups.sortColumn = action.sortColumn
            draft.notAssignedGroups.sortOrder = action.sortOrder
            return draft

        case types.NOT_ASSIGNED_PROJECT_USER_GROUP_FILTERS:
            draft.notAssignedGroups.filters = action.filters
            return draft

        case types.NOT_ASSIGNED_PROJECT_USER_GROUP_SELECTED:
            draft.notAssignedGroups.selected = action.selected
            return draft

            // group users

        case types.ASSIGNED_PROJECT_GROUP_USER_IDS:
            draft.assignedUsers.userIds = action.userIds
            return draft

        case types.ASSIGNED_PROJECT_GROUP_USER_SORT:
            draft.assignedUsers.sortColumn = action.sortColumn
            draft.assignedUsers.sortOrder = action.sortOrder
            return draft

        case types.ASSIGNED_PROJECT_GROUP_USER_FILTERS:
            draft.assignedUsers.filters = action.filters
            return draft

        case types.NOT_ASSIGNED_PROJECT_GROUP_USER_IDS:
            draft.notAssignedUsers.userIds = action.userIds
            return draft

        case types.NOT_ASSIGNED_PROJECT_GROUP_USER_SORT:
            draft.notAssignedUsers.sortColumn = action.sortColumn
            draft.notAssignedUsers.sortOrder = action.sortOrder
            return draft

        case types.NOT_ASSIGNED_PROJECT_GROUP_USER_FILTERS:
            draft.notAssignedUsers.filters = action.filters
            return draft

        case types.NOT_ASSIGNED_PROJECT_GROUP_USER_SELECTED:
            draft.notAssignedUsers.selected = action.selected
            return draft

            // load state

        case types.PROJECT_USER_GROUP_RELOAD_LIST:
            draft.reloadUserGroupList = action.value
            return draft

        case types.PROJECT_GROUP_USER_RELOAD_LIST:
            draft.reloadGroupUserList = action.value
            return draft

        default:
            return draft
    }
})
export default projectUserGroupReducer
